module.exports = __webpack_public_path__ + "static/media/caskshare-stamp-not-a-club-letters-black.64c2126d.svg";